import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import FormContainer from "../FormContainer/FormContainer";
import InputsBlock from "../Layout/InputsBlock";
import RCPROActiviteInputs from "./Inputs/RCPROActiviteInputs";
import useFormState from "./useFormState";
import RCPROGlobalInfoInputs from "./Inputs/RCPROGlobalInfoInputs";
import RCPROSpecificInfoInputs from "./Inputs/RCPROSpecificInfoInputs";
import RCPROGlobalInfoInputs2 from "./Inputs/RCPROGlobalInfoInputs2";
import RCPROComment from "./Inputs/RCPROComment";
import HeadOfficeInfosInputs from "./headOfficeInfos/HeadOfficeInfosInputs";
import GlobalInfosInputs from "./GlobalInfos/GlobalInfosInputs";
import useProductUpdateForm from "../hooks/useProductUpdateForm";
import Loader from "../../../../common/Loader";

const RCPROForm = ({ clientId }) => {
  const { inputsConfig, apiData, formData, actions, errors, rcproForm } =
    useFormState();
  const history = useHistory();

  const { blocksWithError } = useProductUpdateForm({ errors, formData });

  useEffect(() => {
    if (rcproForm.isSaved && Object.keys(errors).length === 0) {
      history.push(`/forms/${clientId}`);
    }
  }, [rcproForm.isSaved]);

  return Object.values(inputsConfig).length > 0 &&
    apiData &&
    rcproForm.isLoaded ? (
    <FormContainer onSubmit={actions.saveForm} isSaving={rcproForm.isSaving}>
      <InputsBlock
        title="Informations de l'entreprise"
        forceOpen={blocksWithError.includes("headOfficeInfosInputs")}
      >
        <HeadOfficeInfosInputs />
      </InputsBlock>
      <InputsBlock
        title="Informations de l'établissement"
        forceOpen={blocksWithError.includes("globalInfosInputs")}
      >
        <GlobalInfosInputs />
      </InputsBlock>
      <InputsBlock
        title="Activités de l'entreprise"
        forceOpen={blocksWithError.includes("activiteInputs")}
      >
        <RCPROActiviteInputs />
      </InputsBlock>
      <InputsBlock
        title="Questions générales"
        forceOpen={blocksWithError.includes("rcproGlobalInfoInputs")}
      >
        <RCPROGlobalInfoInputs />
      </InputsBlock>
      <InputsBlock
        title="Questions spécifiques"
        forceOpen={blocksWithError.includes("rcproSpecificInfoInputs")}
      >
        <RCPROSpecificInfoInputs />
      </InputsBlock>
      <InputsBlock
        title="Questions complémentaires"
        forceOpen={blocksWithError.includes("rcproGlobalInfo2Inputs")}
      >
        <RCPROGlobalInfoInputs2 />
      </InputsBlock>
      <InputsBlock
        title="Commentaire"
        forceOpen={blocksWithError.includes("rcproCommentInputs")}
      >
        <RCPROComment />
      </InputsBlock>
    </FormContainer>
  ) : (
    <Loader />
  );
};

export default RCPROForm;
